<template>
  <div class="tw-flex tw-justify-center tw-items-center tw-w-full">
    <div class="tw-px-12 tw-pt-12 tw-pb-7 tw-font-inter tw-bg-white tw-p-12 tw-w-full tw-m-12 tw-rounded-xl tw-text-black tw-min-h-screen">
      <div class="tw-flex tw-justify-between tw-items-center tw-mb-8">
        <h2 class="tw-font-bold tw-text-5xl">
          Settings
        </h2>
        <button
          class="tw-text-lg tw-bg-[#F1583D] tw-text-white tw-rounded-lg
          tw-px-8 tw-py-4 tw-border-none tw-font-inter tw-cursor-pointer"
          @click="saveChanges"
        >
          Save Changes
        </button>
      </div>

      <!-- Firm-Level Settings: Only show to those with permissions -->
      <h3 class="tw-text-2xl tw-font-bold tw-mb-4">Firm level settings</h3>
      <!-- if not an admin, just show this message -->
      <div v-if="!showFirmLevelSettings">
      <h3 class="tw-text-xl tw-mb-4">Contact your admin for more settings configurations.</h3>
    </div>
    <!-- otherwise show all firm level settings -->
      <div v-if="showFirmLevelSettings">
        <h3 class="tw-text-xl tw-mb-4">The settings below will be applied firm-wide</h3>
        <!-- <p class="tw-mb-10 tw-text-gray-400">
          These settings will be applied firm-wide
        </p> -->

        <div class="tw-flex tw-flex-col tw-justify-center tw-gap-8">
          <div class="tw-grid tw-grid-cols-[200px_1fr] tw-gap-y-8">
            <p class="tw-self-center">Powerpoint Cover Page Title</p>
            <input
              v-model="coverPageTitle"
              type="text"
              class="input is-primary tw-w-full"
              :placeholder="advisorStore?.firmAdvisorCoreSettings?.cover_page_title"
            >

            <p class="tw-self-center">Portfolio Color</p>
            <div class="tw-flex tw-items-center tw-gap-2">
              <input
                v-model="portfolioColor"
                type="color"
                class="tw-w-9 tw-h-8 tw-rounded tw-border-none tw-cursor-pointer"
              >
              <input
                v-model="portfolioColor"
                type="text"
                class="input is-primary tw-w-28"
              >
            </div>

            <p class="tw-self-center">Benchmark Color</p>
            <div class="tw-flex tw-items-center tw-gap-2">
              <input
                v-model="benchmarkColor"
                type="color"
                class="tw-w-9 tw-h-8 tw-rounded tw-border-none tw-cursor-pointer"
              >
              <input
                v-model="benchmarkColor"
                type="text"
                class="input is-primary tw-w-28"
              >
            </div>

            <p class="tw-self-center">Proposed Color</p>
            <div class="tw-flex tw-items-center tw-gap-2">
              <input
                v-model="proposedColor"
                type="color"
                class="tw-w-9 tw-h-8 tw-rounded tw-border-none tw-cursor-pointer"
              >
              <input
                v-model="proposedColor"
                type="text"
                class="input is-primary tw-w-28"
              >
            </div>
                      <!-- <p class="tw-self-center">Proposed Color</p>
          <div class="tw-flex tw-items-center tw-gap-2">
            <input
              v-model="proposedColor"
              type="color"
              class="tw-w-9 tw-h-8 tw-rounded tw-border-none tw-cursor-pointer"
            >
            <input
              v-model="proposedColor"
              type="text"
              class="input is-primary tw-w-28"
            >
          </div> -->
        </div>

        <div class="tw-mt-8">
          <div class="tw-space-y-4">
            <div
              v-for="page in Object.values(pageSettings)"
              :key="page.name"
              class="tw-flex tw-items-center tw-justify-between tw-p-4 tw-bg-gray-100 tw-rounded-lg"
            >
              <PageSetting
                :page="page"
                @updatePageSetting="updatePageSetting"
              />
            </div>
          </div>
          <br>
          </div>
        </div>
      </div>

      <!-- SHOW CUSTOM HOLDINGS FORMAT TO ALL ADVISORS -->
      <div class="tw-mt-8">
        <h3 class="tw-text-2xl tw-font-bold tw-mb-4">Account level settings</h3>
        <h3 class="tw-text-xl tw-mb-4">The settings below will be applied to your account only</h3>
        <p class="tw-mb-4 tw-font-bold tw-text-black-400">
          Custom Holdings Export Format
        </p>
        <p class="tw-mb-4 tw-text-gray-400">
          Customize your holdings export columns: Drag to reorder, rename, or remove unwanted columns.<br>

          The custom format will appear as a second tab in the holdings spreadsheet you download from AdvisorCore.
        </p>

        <!-- Column Headers -->
        <!-- Column Headers -->
        <!-- Column Headers -->
        <!-- Column Headers -->
        <div class="tw-flex tw-items-center tw-justify-between tw-mb-2 tw-px-14">
          <div class="tw-flex tw-gap-4">
            <div class="tw-w-64 tw-font-semibold">Default Name</div>
            <div class="tw-w-64 tw-font-semibold">Custom Name</div>
          </div>
          <a 
            href="#" 
            @click.prevent="revertToDefault" 
            class="tw-text-purple-600 hover:tw-text-purple-800 tw-cursor-pointer tw-text-sm"
          >
            Revert to Default Columns
          </a>
        </div>

        <div class="tw-space-y-4">
          <draggable 
            v-model="selectedColumns"
            class="tw-space-y-2"
            handle=".drag-handle"
          >
            <div
              v-for="column in selectedColumns"
              :key="column"
              class="tw-flex tw-items-center tw-gap-4 tw-bg-gray-100 tw-p-4 tw-rounded-lg"
            >
              <div class="drag-handle tw-cursor-move tw-px-2 tw-py-1 tw-bg-gray-200 tw-rounded hover:tw-bg-gray-300">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tw-text-gray-600">
                  <line x1="8" y1="6" x2="16" y2="6"></line>
                  <line x1="8" y1="12" x2="16" y2="12"></line>
                  <line x1="8" y1="18" x2="16" y2="18"></line>
                </svg>
              </div>
              
              <!-- Default name (now as text instead of dropdown) -->
              <div class="tw-w-64">{{ column }}</div>
              
              <!-- Custom name input -->
              <input
                v-model="holdingsColumnFormat[column]"
                type="text"
                class="input is-primary tw-w-64"
                :placeholder="column"
              >
              
              <button
                @click="removeColumn(column)"
                class="tw-text-red-500 hover:tw-text-red-700"
              >
                ✕
              </button>
            </div>
          </draggable>
          
          <!-- Only show dropdown if there are available columns to add back -->
          <div v-if="availableColumnsNotSelected.length > 0" class="tw-mt-4">
            <select
              v-model="newColumnToAdd"
              class="input is-primary tw-w-64"
              @change="addColumn"
            >
              <option value="">Add a removed column...</option>
              <option
                v-for="col in availableColumnsNotSelected"
                :key="col"
                :value="col"
              >
                {{ col }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <br>
      <button
        class="tw-text-lg tw-bg-[#F1583D] tw-text-white tw-rounded-lg
      tw-px-8 tw-py-4 tw-border-none tw-font-inter tw-cursor-pointer"
        @click="saveChanges"
      >
        Save Changes
      </button>
    </div>
  </div>
</template>


<script>
import { mapStores } from 'pinia';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';
import PageSetting from '@frontend/ui/components/utils/PageSetting.vue';
import draggable from 'vuedraggable';
import * as Sentry from '@sentry/vue';

export default {
  name: 'SettingsArea',
  components: { PageSetting, draggable },
  data() {
    return {
      coverPageTitle: '',
      portfolioColor: '',
      benchmarkColor: '',
      proposedColor: '',
      // holdings output format specifications
      availableColumns: [
        'Notes',
        'Symbol/CUSIP',
        'Name',
        'Quantity',
        'Cost Basis',
        'Market Value',
        'Fees',
        'Account',
        'Account Registration',
        'Account Tax Status'
      ],
      holdingsColumnFormat: {}, // This will store original column names->custom mappings
      selectedColumns: [],// This maintains order
      newColumnToAdd: ''
      };
  },
  watch: {
  'advisorStore.firmAdvisorCoreSettings'(newSettings) {
    if (newSettings) {
      console.log('NEW SETTINGS', newSettings);
      console.log('HOLDINGS FORMAT:', newSettings.holdings_column_format);
      this.coverPageTitle = newSettings.cover_page_title || '';
      this.portfolioColor = newSettings.portfolio_color || '#40B6D8';
      this.benchmarkColor = newSettings.benchmark_color || '#8C67EF';
      this.proposedColor = newSettings.proposed_color || '#27A683';

      if (newSettings.holdings_column_format) {
        console.log('Updating holdings format with:', newSettings.holdings_column_format);
      } else {
        console.log('No holdings format found in settings');
      }

      // Only update if holdings format exists
      if (newSettings.holdings_column_format?.length) {
        this.selectedColumns = newSettings.holdings_column_format.map(item => item.original);
        this.holdingsColumnFormat = {};
        newSettings.holdings_column_format.forEach(item => {
          this.holdingsColumnFormat[item.original] = item.custom;
        });
      }
    }
  },
  },
  created() {
    //firm level stuff
    if (this.advisorStore?.firmAdvisorCoreSettings) {
      this.coverPageTitle = this.advisorStore.firmAdvisorCoreSettings.cover_page_title || '';
      this.portfolioColor = this.advisorStore.firmAdvisorCoreSettings.portfolio_color || '#40B6D8';
      this.benchmarkColor = this.advisorStore.firmAdvisorCoreSettings.benchmark_color || '#8C67EF';

      this.proposedColor = this.advisorStore.firmAdvisorCoreSettings.proposed_color || '#27A683';
    }
    // custom holdings export
    // Initialize holdings format from existing settings if they exist
    if (this.advisorStore.advisorHoldingsFormat) {
      const holdings_format = this.advisorStore.advisorHoldingsFormat
      console.log('existing custom holdings export format already found,', holdings_format)
      this.selectedColumns = this.advisorStore.advisorHoldingsFormat.map(item => item.original);
      this.holdingsColumnFormat = {};
      this.advisorStore.advisorHoldingsFormat.forEach(item => {
        this.holdingsColumnFormat[item.original] = item.custom;
      });
    } else {
      console.log('existing custom holdings export format NOT found')
      // Only initialize with all columns if no existing settings
      this.selectedColumns = [...this.availableColumns];
      this.availableColumns.forEach(column => {
        this.holdingsColumnFormat[column] = column;
      });
    }
  },
  computed: {
    ...mapStores(useAdvisorStore),
    showFirmLevelSettings() {
      // Only admin or those with edit firm settings permissions can view firm-wide settings
      return this.advisorStore.canEditFirmSettings;
    },
    pageSettings() {
      return this.advisorStore.pageSettings;
    },
    availableColumnsNotSelected() {
    return this.availableColumns.filter(col => !this.selectedColumns.includes(col));
    },
    headers() {
      return {
        'X-CSRFToken': this.$root.$data.csrfToken,
        'Content-Type': 'application/json',
      };
    },
  },
  methods: {
    updatePageSetting(pageName, isIncluded) {
      if (this.pageSettings[pageName]) {
        this.pageSettings[pageName].isIncluded = isIncluded;
      }
    },
    revertToDefault() {
      this.selectedColumns = [...this.availableColumns];
      this.holdingsColumnFormat = {};
      this.availableColumns.forEach(column => {
        this.holdingsColumnFormat[column] = column;
      });
    },
    addColumn(event) {
    const column = event.target.value;
    if (column) {
      this.selectedColumns.push(column);
      this.holdingsColumnFormat[column] = column; // Default to same name
      event.target.value = ''; // Reset select
    }
    },
    
    removeColumn(column) {
      this.selectedColumns = this.selectedColumns.filter(col => col !== column);
      delete this.holdingsColumnFormat[column];
    },
    async saveChanges() {
      try {
        const url = `/api/v1/portfolio_checkup/settings/`;
        
        // Convert holding columns to new format
        const columnFormat = this.selectedColumns.map(col => ({
          original: col,
          custom: this.holdingsColumnFormat[col] !== col && this.holdingsColumnFormat[col] !== '' 
            ? this.holdingsColumnFormat[col] 
            : col
        }));

        const res = await fetch(url, {
          method: 'POST',
          headers: this.headers,
          body: JSON.stringify({
            cover_page_title: this.coverPageTitle,
            page_settings: this.pageSettings,
            portfolio_color: this.portfolioColor,
            benchmark_color: this.benchmarkColor,
            proposed_color: this.proposedColor,
            holdings_column_format: columnFormat
          }),
        });

        // Check if response is OK
        if (!res.ok) {
          throw new Error(`Server responded with status: ${res.status}`);
        }

        const data = await res.json();
        console.log('Save settings response:', data);
        
        // Only update local data if response contains expected data
        if (data && data.success) {
          // Update holdings format if available
          if (data.settings && data.settings.holdings_column_format) {
            this.advisorStore.setAdvisorHoldingsFormat(data.settings.holdings_column_format)
            this.selectedColumns = data.settings.holdings_column_format.map(item => item.original);
            this.holdingsColumnFormat = {};
            data.settings.holdings_column_format.forEach(item => {
              this.holdingsColumnFormat[item.original] = item.custom;
            });
          }

          // Update store only if data exists
          if (data.settings) {
            this.advisorStore.setFirmAdvisorCoreSettings(data.settings);
          }
          if (data.pageSettings) {
            this.advisorStore.setPageSettings(data.pageSettings);
          }
          
          // Show success notification
          this.$oruga.notification.open({
            message: 'Settings saved! Please refresh the page to see changes.',
            variant: 'success',
            position: 'top-right',
            duration: 5000,
          });
        } else {
          // Handle case where success is false or missing
          console.error('Save failed: Response indicates failure', data);
          throw new Error('Save operation failed');
        }
      } catch (err) {
        // Log to console and Sentry
        console.error('Failed to save advisorcore settings:', err);
        Sentry.captureException(err);
        
        // Notify user
        this.$oruga.notification.open({
          message: 'Error saving settings. The YourStake team has been notified.',
          variant: 'danger',
          position: 'top-right',
          duration: 7000,
        });
      }
    },
  },
};
</script>

<style scoped>
input[type="color"] {
  -webkit-appearance: none;
  border: none;
  padding: 0;
}
input[type="color"]::-webkit-color-swatch-wrapper {
  padding: 0;
}
input[type="color"]::-webkit-color-swatch {
  border: none;
  border-radius: 4px;
}
</style>
